import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { cloneDeep, forEach, keys } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';
import { ContactMatrix } from '../../../../core/models/contact-matrix.model';
import { List } from '../../../../core/models/list.model';
import { CommonUtilService } from '../../../../shared/services/CommonUtil.service';
import { JOB_LABELS } from '../../../../shared/services/job_labels.service';
import { Lists } from '../../../../shared/services/lists.service';
import { SavedSearches } from '../../../../shared/services/saved-searches.service';
import { CompanyService } from '../../../companies/services/companies.service';
import { ContactsService } from '../../../contacts/services/contacts.service';
import { LoadingService, RequestBodyService, TagService } from '../../../../shared/services';
import { UniversalSearchModel } from '../../../../core/models/universal-search.model';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { SearchService } from '../../../search/services/search.service';
import { RequestResearchModalComponent } from '../../../../shared/components/request-research-modal/request-research-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ListApiService, TagsApiService } from '../../../../shared/services/api';
import { AccountAttributesEnum } from 'src/app/shared/enums';
import { ListsSearchTypes } from 'src/app/shared/enums/lists-search-types';
import {  MAT_DIALOG_DATA,  MatDialog,  MatDialogConfig,  MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ListItemDto, SaveTagDto, TagsDto } from 'src/app/shared/dto';
import { CREATE_TAG_LOADING_TAG, GET_TAG_LOADING_TAG } from 'src/app/shared/constants';

@UntilDestroy()
@Component({
    selector: 'app-create-company-list',
    templateUrl: './create-company-list.component.html',
    styleUrls: ['./create-company-list.component.scss'],
    standalone: false
})
export class CreateCompanyListComponent implements OnInit, OnDestroy {
    @ViewChild('listFile') listFile: ElementRef;

    readonly isCreateTagLoading$: Observable<boolean> = this.loadingService.getIsLoading(CREATE_TAG_LOADING_TAG);
    readonly isGetTagLoading$: Observable<boolean> = this.loadingService.getIsLoading(GET_TAG_LOADING_TAG);

    public pages = {
        uploadListPage: 0,
        columnMappingPage: 1,
        resultPage: 2
    };
    unmatchedList = [];
    duplicatedList = [];
    invalidList = [];
    matchedDomainList = [];
    isHumanVerified: boolean = false;
    companyIdList = [];
    totalCount;
    listName;
    headers = [{
        Title: 'Accounts',
        Description: 'Upload your accounts',
        IsDone: false,
        IsActive: true
    }, {
        Title: 'Map Fields',
        Description: 'Assign csv columns to company fields',
        IsDone: false,
        IsActive: false
    }, {
        Title: 'Results',
        Description: 'Get your Account Based Contacts grouped by level and department',
        IsDone: false,
        IsActive: false
    }];

    currentPage = 0;
    existingLists: ListItemDto[] = [];
    list: List = new List();
    fileHeaders = undefined;

    selectedColumnValues = {
        companyDomain: '0',
        company: '0'
    };

    columnStepDetails = [
        { displayName: 'Domain', propertyName: 'companyDomain', isError: false },
        { displayName: 'Name', propertyName: 'company', isError: false }
    ];
    isError;

    isListProcessing = false;
    buyingCenterDetails = {
        usaHumanVerifiedCount: 0,
        usaMachineVerifiedCount: 0,
        intlHumanVerifiedCount: 0,
        intlMachineVerifiedCount: 0,
        verified: 0,
        machine: 0,
        unmatched: 0,
        duplicates: 0,
        invalid: 0,
        total_aggr: 0,
        matched: 0
    };
    jobLevelLabels = JOB_LABELS.levels;
    jobLevelKeys = keys(this.jobLevelLabels);
    jobDepartmentLabels = JOB_LABELS.departments;
    jobDepartmentKeys = keys(this.jobDepartmentLabels);
    nextButtonCaption = 'Next';
    verifiedContacts: ContactMatrix[] = [new ContactMatrix(), new ContactMatrix()];
    subscriber: any;
    accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;

    tagList$: Observable<TagsDto[]>;

    constructor(
        private listsService: Lists,
        private toastr: ToastrService,
        private requestBodyService: RequestBodyService,
        private router: Router,
        public contactsService: ContactsService,
        private companiesService: CompanyService,
        public commonUtilService: CommonUtilService,
        private saveSearch: SavedSearches,
        private searchService: SearchService,
        public auth: AuthenticationService,
        private readonly listApiService: ListApiService,
        private readonly matDialog: MatDialog,
        private matDialogRef: MatDialogRef<CreateCompanyListComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
        private readonly tagsApiService: TagsApiService,
        private readonly loadingService: LoadingService,
        private readonly tagService: TagService
    ) {
        this.list.type = 'Companies';
        if (this.data) {
            if (this.data['id']) {
                this.list.id = this.data['id'];
                this.listName = this.list.name ? this.list.name : this.data['name'];
                this.contactsService.createContactLoadedFlag.next(true);
                this.currentPage = 2;
                this.getListDetails();
                this.setNextButtonCaption();
                this.headers = [{
                    Title: this.listName,
                    Description: '',
                    IsDone: false,
                    IsActive: true
                }];
            }

            if (this.data['files']) {
                this.list.file = this.data['files'];
                this.list.fileName = this.list.file['name'];
            }
        }
    }

    ngOnInit() {
        this.listsService.listData$.pipe(untilDestroyed(this)).subscribe((data: ListItemDto[]) => {
            this.existingLists = data;
        });

        this.verifiedContacts[0].IsHumanVerified = true;
        this.verifiedContacts[1].IsHumanVerified = false;
        this.setTagsList();
    }

    createTag(tagName: string): void {
        const createObj: SaveTagDto = {
            name: tagName
        }
        this.loadingService.loadingWrapper(this.tagsApiService.createTag(createObj), CREATE_TAG_LOADING_TAG).pipe(untilDestroyed(this)).subscribe((newTag: TagsDto) => {
            this.list = {...this.list, tags: [...this.list.tags, newTag.id]};
            this.tagService.refreshList();
            this.toastr.success("Tag created successfully");
        })
    }

    ngOnDestroy() {
        if (this.subscriber) {
            this.subscriber.unsubscribe();
        }
    }

    close(): void {
        this.matDialogRef.close();
    }

    onNext(): void {
        switch (this.currentPage) {
            case this.pages.uploadListPage:
                this.createPreviewList();
                break;
            case this.pages.columnMappingPage:
                this.isListProcessing = true;
                this.contactsService.createContactLoadedFlag.next(true);
                this.createList();
                break;
            default:
                this.close();
                break;
        }
    }

    onPrevious(): void {
        this.headers[this.currentPage].IsDone = false;
        this.headers[this.currentPage].IsActive = false;
        this.currentPage--;
        this.headers[this.currentPage].IsActive = true;
        this.headers[this.currentPage].IsDone = false;
        this.setNextButtonCaption();
    }

    onFileSelected(event) {
        if (event.target.files.length > 0) {
            this.list.file = event.target.files[0];
            this.list.fileName = event.target.files[0].name;
        }
    }

    private createPreviewList() {
        const listName = this.list.name === undefined ? '' : this.list.name.trim();
        const nameExist = this.existingLists.filter((item) => item.name.toLowerCase() === listName.toLowerCase()).length > 0;
        const filename = this.list.fileName;
        const fileParts = filename.split('.');
        const extension = fileParts[fileParts.length - 1];

        if (listName === '') {
            this.commonUtilService.showToastWithError('List Name is required');
            return;
        }
        if (filename === '') {
            this.commonUtilService.showToastWithError('CSV File is required');
            return;
        }
        if (nameExist) {
            this.commonUtilService.showToastWithError('You already have a list with this name. Please choose a different name.');
            return;
        }
        if (extension !== 'csv' && extension !== 'txt') {
            this.commonUtilService.showToastWithError('Only .txt or .csv files are supported. Please choose a file with one of those two extensions.');
            return;
        }

        this.isListProcessing = true;
        this.contactsService.createContactLoadedFlag.next(true);
        this.listsService.createPreviewList(this.list).subscribe((response) => {
            this.isListProcessing = false;
            this.contactsService.createContactLoadedFlag.next(false);
            this.fileHeaders = response.columns[0].split(',');
            forEach(this.fileHeaders, (value, index) => {
                const lowerCaseValue = (value.toLowerCase()).trim();
                if (lowerCaseValue === 'domain' || lowerCaseValue === 'website' || lowerCaseValue === 'url' ||
                    lowerCaseValue === 'link' || lowerCaseValue === 'site' || lowerCaseValue === 'webpage' ||
                    lowerCaseValue === 'web page' || lowerCaseValue === 'homepage' || lowerCaseValue === 'home page') {
                    this.selectedColumnValues.companyDomain = index + 1;
                } else if (lowerCaseValue === 'name' || lowerCaseValue === 'company' || lowerCaseValue === 'company name' || lowerCaseValue === 'companyname' ||
                    lowerCaseValue === 'organization' || lowerCaseValue === 'corporation' || lowerCaseValue === 'enterprise' ||
                    lowerCaseValue === 'firm') {
                    this.selectedColumnValues.company = index + 1;
                }
            });
            this.proceedToNextStep();
            this.setNextButtonCaption();
        }, () => {
            this.isListProcessing = false;
            this.contactsService.createContactLoadedFlag.next(false);
        });
    }

    private createList() {
        if (this.selectedColumnValues.companyDomain === '0' && this.selectedColumnValues.company === '0') {
            this.isError = 'Your file must contain either a domain OR a name.';
            this.contactsService.createContactLoadedFlag.next(false);
            return;
        }
        const isDuplicate = this.commonUtilService.checkDupicateMappings(this.selectedColumnValues, this.columnStepDetails);
        if (isDuplicate === false) {
            this.list.columnMapping = this.selectedColumnValues;
            this.list.name = this.list.name === undefined ? '' : this.list.name.trim();
            this.listsService.createList(this.list).subscribe((response) => {
                this.listsService.refreshLists();
                this.list.id = response.id;
                this.listName = response.name;
                this.getListDetails();
                this.proceedToNextStep();
                this.setNextButtonCaption();
                this.isListProcessing = false;
            }, () => {
                this.isListProcessing = false;
                this.contactsService.createContactLoadedFlag.next(false);
            });
        } else {
            this.isListProcessing = false;
            this.contactsService.createContactLoadedFlag.next(false);
        }
    }

    private getListDetails() {
        this.verifiedContacts[0].ListId = this.list.id;
        this.verifiedContacts[1].ListId = this.list.id;
        const pairs = [];
        this.jobLevelKeys.forEach((jobLevel) => {
            this.jobDepartmentKeys.forEach((jobDepartment) => {
                const pair = { job_level: jobLevel, job_department: jobDepartment };
                pairs.push(pair);
            });
        });
        this.subscriber = this.listApiService.analyzeCompanyList(this.list.id, pairs).pipe(untilDestroyed(this)).subscribe((responseData) => {
            this.verifiedContacts[0].Contacts =  responseData.verified[0];
            this.verifiedContacts[1].Contacts =  responseData.all_contacts[0];
            this.updateTotals(this.verifiedContacts[0]);
            this.updateTotals(this.verifiedContacts[1]);

            this.matchedDomainList = responseData.matchedDomains;

            this.buyingCenterDetails.usaHumanVerifiedCount = responseData.usDomainVerifiedCount ? responseData.usDomainVerifiedCount : 0;
            this.buyingCenterDetails.usaMachineVerifiedCount = responseData.usDomainAllCount || 0;
            this.buyingCenterDetails.intlHumanVerifiedCount = responseData.internationalDomainVerifiedCount ? responseData.internationalDomainVerifiedCount : 0;
            this.buyingCenterDetails.intlMachineVerifiedCount = responseData.internationalDomainAllCount || 0;

            this.buyingCenterDetails.matched = responseData.matchedDomainCount ? responseData.matchedDomainCount : 0;
            this.buyingCenterDetails.unmatched = responseData.unmatchedCount ? responseData.unmatchedCount : 0;
            this.buyingCenterDetails.duplicates = responseData.duplicatesCount ? responseData.duplicatesCount : 0;
            this.buyingCenterDetails.invalid = responseData.invalidDomainCount ? responseData.invalidDomainCount : 0;

            this.unmatchedList = responseData.unmatchedList;
            this.duplicatedList = responseData.duplicateList;
            this.invalidList = responseData.invalidList;
            this.totalCount = responseData.total_count;
            const finalCount = (this.totalCount - this.buyingCenterDetails.duplicates - this.buyingCenterDetails.invalid);
            const resultValue = (this.buyingCenterDetails.matched / finalCount);

            let matchedTotalPercent = '0%';
            if (this.totalCount !== 0) {
                matchedTotalPercent = (resultValue > 1) ? '100%' : (Math.round(resultValue * 100) + '%');
            }

            if (this.list.name) {
                this.headers[2].Description = (this.totalCount - this.buyingCenterDetails.unmatched - this.buyingCenterDetails.duplicates - this.buyingCenterDetails.invalid).toLocaleString() + ' of ' + (this.totalCount - this.buyingCenterDetails.duplicates - this.buyingCenterDetails.invalid).toLocaleString() + ' companies matched ' + '(' + matchedTotalPercent + ')';
            } else {
                this.headers[0].Description = (this.totalCount - this.buyingCenterDetails.unmatched - this.buyingCenterDetails.duplicates - this.buyingCenterDetails.invalid).toLocaleString() + ' of ' + (this.totalCount - this.buyingCenterDetails.duplicates - this.buyingCenterDetails.invalid).toLocaleString() + ' companies matched ' + '(' + matchedTotalPercent + ')';
            }

            this.verifiedContacts[0].TotalContacts = responseData.verified_count;
            this.verifiedContacts[1].TotalContacts = responseData.all_contacts_count;
            this.contactsService.createContactLoadedFlag.next(false);
        }, () => {
            this.contactsService.createContactLoadedFlag.next(false);
        });
    }


    private updateTotals(data) {
        for(let level in data.Contacts) {
            data.LevelTotals[level] = Object.values(data.Contacts[level]).reduce((total: number, value: number) => total + value, 0);
            for(let department in data.Contacts[level]) {
                if(!data.DepartmentTotals[department]) {
                    data.DepartmentTotals[department] = 0;
                }
                data.DepartmentTotals[department] += data.Contacts[level][department] || 0;
            }
        }
    }

    private proceedToNextStep() {
        this.headers[this.currentPage].IsDone = true;
        this.headers[this.currentPage].IsActive = false;
        this.currentPage++;
        this.headers[this.currentPage].IsActive = true;
    }

    private setNextButtonCaption() {
        switch (this.currentPage) {
            case 1:
                this.nextButtonCaption = 'Save List';
                break;
            case 2:
                this.nextButtonCaption = 'Close';
                break;
            default:
                this.nextButtonCaption = 'Next';
                break;
        }
    }

    onContactClick() {
        this.matDialogRef.close();
    }

    onRoDModal(rodType) {
        if (this.commonUtilService.hasRODCreditsRemaining) {
            const companiesList = [];
            let companyData;
            let rodList;
            let rodTypeList = [];
            let rodContactType = '';
            if (rodType === 'unmatched') {
                rodTypeList = this.unmatchedList;
                rodTypeList.map((item) => {
                    if (item.companyName && item.companyDomain) {
                        rodList = item.companyDomain + ' | ' + item.companyName;
                    } else {
                        const compDomain = (item.companyDomain ? item.companyDomain : '');
                        const compName = (item.companyName ? ' | ' + item.companyName : '');
                        rodList = compDomain ? (compDomain + compName) : (item.companyName ? item.companyName : '');
                    }
                    rodContactType = 'UnMatched';
                    companiesList.push(rodList);
                    companyData = companiesList.join('\n');
                });
            }

            const initialState: MatDialogConfig = {
                panelClass: 'modal-md',
                data: {
                    title: 'Request Research',
                    labelText: 'Provide your research criteria (title, level, department, etc)',
                    placeHolderText: 'Tell us what’s going on with the company(optional).',
                    saveButtonText: 'Submit',
                    closeButtonText: 'Close',
                    inputValue: '',
                    mandatoryInput: true,
                }
            };
            this.matDialog.open(RequestResearchModalComponent, initialState).afterClosed().pipe(untilDestroyed(this)).subscribe((data: any) => {
                if (data && data.success) {
                    this.companiesService.isLoader = true;
                    this.companiesService.provideFeedback({
                        from: 'Portal',
                        details: '\n\nFileName: ' + this.listName + '\n\nComment: ' + data.inputValue + '\n\nDetails:\n' + rodContactType + '\n' + companyData,
                        title: data.requestName
                        // details: data.inputValue + '\n'+ 'This request was made from the ' + rodType +' companies of the company list named ' + listName +'. Companies to find contacts for:' + '\n' + companyData
                    }).pipe(untilDestroyed(this)).subscribe((response) => {
                        this.companiesService.isLoader = false;
                        this.toastr.success('Requested successfully!');
                    }, () => {
                        this.companiesService.isLoader = false;
                    });
                }
            });
        } else {
            this.commonUtilService.displayExhaustedRodMessage();
        }
    }

    onViewCompanies(searchType: ListsSearchTypes) {
        let companySearch;
        companySearch = cloneDeep(UniversalSearchModel);
        companySearch.request_type = 'COMPANIES'
        if (searchType === ListsSearchTypes.INTL_HUMAN || searchType === ListsSearchTypes.INTL_MACHINE) {
            companySearch.location_country_codes = [];
        }
        if (searchType === ListsSearchTypes.USA_HUMAN) {
            companySearch.verified = 1;
            companySearch.is_international = 0;
            companySearch['accuracy_tier_company'] = 'HV';
        } else if (searchType === ListsSearchTypes.USA_MACHINE) {
            companySearch.verified = 0;
            companySearch.is_international = 0;
            companySearch['accuracy_tier_company'] = 'MV';
        } else if (searchType === ListsSearchTypes.INTL_HUMAN) {
            companySearch.verified = 1;
            companySearch.is_international = 1;
            companySearch['accuracy_tier_company'] = 'HV';
        } else if (searchType === ListsSearchTypes.INTL_MACHINE) {
            companySearch.verified = 0;
            companySearch.is_international = 1;
            companySearch['accuracy_tier_company'] = 'MV';
        }

        companySearch.lists = [this.list.id];
        this.saveSearch.currentCompanySearchId = '';
        this.saveSearch.companyActiveSearch = '';
        this.companiesService.resultPage.resultData = [];
        this.companiesService.resultPage.verifiedData = [];
        this.companiesService.resultPage.verifiedDataType = null;
        this.requestBodyService.changeContactBodyData(undefined);// added for 881
        this.requestBodyService.changeCompanyBodyData(undefined); // added for 4183
        this.requestBodyService.clearSearchSidebar.next(true);
        this.saveSearch.welComeLoadedCompanyFlag.next(true);
        this.companiesService.companyLoadedFlag.next(true); // added for 4177
        this.companiesService.resultPage.companySidebarData = companySearch;
        this.contactsService.resultPage.contactSidebarData = companySearch;
        this.searchService.changeSelectedTab.next('COMPANIES');
        this.router.navigate(['results/search']);
        setTimeout(() => {
            this.searchService.universalCount = null;
            this.requestBodyService.changeCompanyBodyData(companySearch);
        }, 1000);
        // this.router.navigate(['results/companies']);

        this.close();

    }

    onExport(searchType, exportType) {
        this.companyIdList = [];
        if (searchType === 'matched') {
            this.commonUtilService.csvCompanyExportAllWithoutAPI(this.matchedDomainList, searchType, exportType, this.listName);
        } else if (searchType === 'unmatched') {
            this.commonUtilService.csvCompanyExportAllWithoutAPI(this.unmatchedList, searchType, exportType, this.listName);
        } else if (searchType === 'duplicate') {
            this.commonUtilService.csvCompanyExportAllWithoutAPI(this.duplicatedList, searchType, exportType, this.listName);
        } else if (searchType === 'invalid') {
            this.commonUtilService.csvCompanyExportAllWithoutAPI(this.invalidList, searchType, exportType, this.listName);
        }
    }

    isNextButtonDisabled() {
        if (this.currentPage === 0) {
            return this.list.fileName === undefined || this.list.fileName === '' || this.list.name === undefined || this.list.name === '';
        }
        return false;
    }

    resetFile() {
        this.fileHeaders = undefined;
        this.list.file = undefined;
        this.list.fileName = undefined;
        this.listFile.nativeElement.value = '';
        this.selectedColumnValues.companyDomain = '0';
        this.selectedColumnValues.company = '0';
    }

    private setTagsList(): void {
        this.tagList$ = this.tagService.getTagsList();
    }
}
